const VOICE_LEARNING_STORAGE_KEY = 'flicube_voice_command_aliases_v1'
const MAX_LEARNED_ALIASES = 100

const WAKE_WORDS = [
  '飞行魔方', '飞行模仿', '飞行魔法', '飞行磨坊', '飞翔魔方', '飞行模块', '飞行魔坊'
]

const COMMAND_DEFINITIONS = {
  hook_down: {
    key: 'hook_down',
    label: '放钩',
    confirmMessage: '确认放钩一次？请确认飞机处于加锁安全状态。'
  },
  hook_recovery: {
    key: 'hook_recovery',
    label: '收钩',
    confirmMessage: '确认立即收钩？请留意挂载仓及周围人员。'
  },
  calibrate: {
    key: 'calibrate',
    label: '校准',
    confirmMessage: '确认校准重量传感器？请确认飞机已加锁且挂钩处于安全状态。'
  }
}

const STATIC_ALIASES = {
  hook_recovery: [
    '收钩', '收购', '收够', '收勾', '收沟', '收狗',
    '手钩', '手勾', '手沟', '手狗', '回收', '回收钩子', '收回钩子'
  ],
  calibrate: [
    '校准', '较准', '矫准', '校正', '矫正', '调准',
    '校准挂钩', '挂钩校准', '校准传感器', '传感器校准'
  ],
  hook_down: [
    '放钩', '下钩', '放勾', '放沟', '放狗', '放够',
    '防钩', '防勾', '防沟', '防狗', '放下钩子'
  ]
}

function normalizeVoiceText (spokenText) {
  return String(spokenText || '').replace(/[，。！？、,.!?\s]/g, '')
}

function normalizeCommandText (spokenText) {
  return normalizeVoiceText(spokenText).replace(/^(?:请|执行|挂钩|钩子)+/, '')
}

function createCommand (key, extra = {}) {
  const command = COMMAND_DEFINITIONS[key]
  return command ? { ...command, ...extra } : null
}

function readLearnedAliases () {
  if (typeof window === 'undefined' || !window.localStorage) return {}
  try {
    const data = JSON.parse(window.localStorage.getItem(VOICE_LEARNING_STORAGE_KEY) || '{}')
    return data && typeof data === 'object' && !Array.isArray(data) ? data : {}
  } catch (error) {
    return {}
  }
}

function saveLearnedAlias (text, key, count = 1) {
  if (typeof window === 'undefined' || !window.localStorage || !text) return
  try {
    const aliases = readLearnedAliases()
    const oldItem = aliases[text] || {}
    aliases[text] = {
      key,
      count: Number(oldItem.count || 0) + Number(count || 1),
      lastUsed: Date.now()
    }
    const entries = Object.entries(aliases)
      .sort((a, b) => Number(b[1].lastUsed || 0) - Number(a[1].lastUsed || 0))
      .slice(0, MAX_LEARNED_ALIASES)
    const limitedAliases = entries.reduce((result, item) => {
      result[item[0]] = item[1]
      return result
    }, {})
    window.localStorage.setItem(VOICE_LEARNING_STORAGE_KEY, JSON.stringify(limitedAliases))
  } catch (error) {
    console.warn('保存语音学习词典失败', error)
  }
}

function inferCommandKey (text) {
  if (/^(?:收|手|首|守|瘦).{1,3}$/.test(text) || text.includes('回收')) return 'hook_recovery'
  if (/^(?:放|防|方).{1,3}$/.test(text) || text.includes('放下')) return 'hook_down'
  const hasCalibrationPrefix = /[校较矫教调]/.test(text)
  const hasCalibrationSuffix = /[准正证整]/.test(text)
  if (hasCalibrationPrefix && hasCalibrationSuffix) return 'calibrate'
  return ''
}

export function parseWakePhrase (spokenText) {
  const text = normalizeVoiceText(spokenText)
  const wakeWord = WAKE_WORDS.find(item => text.includes(item))
  if (!wakeWord) return null
  return {
    wakeWord,
    commandText: text.slice(text.indexOf(wakeWord) + wakeWord.length)
  }
}

export function parseVoiceCommand (spokenText) {
  const normalized = normalizeCommandText(spokenText)
  const learnedItem = readLearnedAliases()[normalized]
  if (learnedItem && COMMAND_DEFINITIONS[learnedItem.key]) {
    return createCommand(learnedItem.key)
  }

  const matchedKey = Object.keys(STATIC_ALIASES).find(key => STATIC_ALIASES[key].includes(normalized))
  return createCommand(matchedKey)
}

export function inferVoiceCommand (spokenText) {
  const normalized = normalizeCommandText(spokenText)
  if (!normalized || normalized.length > 6) return null
  const key = inferCommandKey(normalized)
  if (!key) return null
  return createCommand(key, {
    learningCandidate: true,
    learnedText: normalized
  })
}

export function persistLearnedVoiceAlias (spokenText, key, count = 1) {
  const normalized = normalizeCommandText(spokenText)
  if (!normalized || !COMMAND_DEFINITIONS[key]) return
  saveLearnedAlias(normalized, key, count)
}

export function getLearnedVoiceAliases () {
  return readLearnedAliases()
}
